import React, { useState, useRef, useEffect } from 'react';
import { Send } from 'lucide-react';

export default function SageChatInput({ onSend, isLoading, focusTrigger }) {
  const [value, setValue] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    if (!isLoading && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isLoading, focusTrigger]);

  const handleSend = () => {
    const trimmed = value.trim();
    if (!trimmed || isLoading) return;
    onSend(trimmed);
    setValue('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="flex items-end gap-2 p-3 border-t border-gray-200 bg-white">
      <textarea
        ref={inputRef}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Ask about your data..."
        rows={1}
        className="flex-1 resize-none rounded-lg border border-gray-300 px-3 py-2 text-sm
                   focus:outline-none focus:ring-2 focus:ring-amber-400 focus:border-amber-400
                   placeholder:text-gray-400"
        style={{ minHeight: '38px', maxHeight: '120px' }}
        onInput={(e) => {
          e.target.style.height = 'auto';
          e.target.style.height = Math.min(e.target.scrollHeight, 120) + 'px';
        }}
      />
      <button
        onClick={handleSend}
        disabled={isLoading || !value.trim()}
        className="flex-shrink-0 w-9 h-9 rounded-lg bg-amber-500 text-white
                   flex items-center justify-center
                   hover:bg-amber-600 disabled:opacity-40 disabled:cursor-not-allowed
                   transition-colors"
      >
        <Send className="w-4 h-4" />
      </button>
    </div>
  );
}
